import { Injectable } from "@angular/core";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { namelessDayOfWeekFormat } from "devexpress-dashboard/model/index.metadata";
import { of } from "rxjs";
import { tap, catchError } from "rxjs/operators";
import { DashboardGlobalDto, DashboardParcDto } from "src/api/models";
import { DashboardsService } from "src/api/services";
import { Dashboards } from "./dashboard.actions";
import { DashboardState, DashboardStateDefault } from "./dashboard.state";


@State<DashboardState>({
  name: 'dashboard',
  defaults: DashboardStateDefault,
})
@Injectable()
export class DashboardStore {

  constructor(private dashboardService: DashboardsService) {
  }

  @Selector()
  static global$(state: DashboardState) {
    return state.globalData;
  }

  @Selector()
  static parc$(state: DashboardState) {
    return state.parcData;
  }

  @Action(Dashboards.CleanStore)
  CleanStore( { patchState }:StateContext<DashboardState>) {
    patchState( {
      globalData: null,
      parcData: null,
      error: null
    });
  }

  @Action(Dashboards.GetGlobalData)
  getGlobalData( { patchState }:StateContext<DashboardState>) {
    return this.dashboardService.dashboardGetGlobal().pipe(
      tap( (res: DashboardGlobalDto) => {
        patchState( {
          globalData: res,
          error: null
        })
      }),
      catchError( (error: Error) => {
        patchState({
          globalData: null,
          error: error.message
        });
        return of(error);
      })
    )
  }

  @Action(Dashboards.GetParcData)
  getParcData( { patchState }: StateContext<DashboardState>, { parcId }: Dashboards.GetParcData) {
    return this.dashboardService.dashboardGetParc( { parcId }).pipe(
      tap( (res: DashboardParcDto) => {
        patchState({
          parcData: res,
          error: null
        });
      }),
      catchError( (error: Error) => {
        patchState({
          parcData: null,
          error: error.message
        });
        return of(error);
      })
    );
  }

}
